export class BaseServerFilterEntity {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	constructor(public Value: any, public Label: string, public Key: string) {}
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	static isBaseServerFilterEntity(value: any): boolean {
		if (!value) {
			return false;
		}
		if (value instanceof BaseServerFilterEntity) {
			return true;
		}

		// checks if object has shape of BaseServerFilterEntity
		// used when restoring filter from localstorage
		if (value.constructor === Object) {
			const keys = ['Value', 'Label', 'Key'];
			return keys.every((key) => key in value);
		}
		return false;
	}
}
